// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"197":"45b90b6a","238":"72a0faa8","456":"a0f55f7e","694":"e9a042eb","787":"a40efc1c","815":"59fa4491","879":"ebd39bb2"}[chunkId] + ".chunk.js";
};